// import PropTypes from 'prop-types';
import React, { Component } from 'react';

class GenericContextItem extends Component {
  _callback = () => {
    const { callback, i, callbackRetrieval, position } = this.props;

    callback(position, i[callbackRetrieval]);
  }

  render() {
    const { i, titleRetrieval } = this.props;
    return <a onClick={this._callback} className="dropdown-item">{i[titleRetrieval]}</a>;
  }
};

GenericContextItem.propTypes = {
};

export default GenericContextItem;



// WEBPACK FOOTER //
// ./src/components/buttons/GenericContextMenu/GenericContextItem.js